import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UniversidadeComponent } from './universidade.component';
import { UniversidadeRouter } from './universidade.router';

import { NucleoService } from './nucleo/shared/nucleo.service'

import { SharedModule } from '../shared/shared.module';
import { NoticiasModule } from './noticias/noticias.module';
import { NucleoComponent } from './nucleo/nucleo.component';
import { NucleoDetalhesComponent } from './nucleo/nucleo-detalhes/nucleo-detalhes.component';
import { BolsasFinanciamentoModule } from './bolsas-financiamento/bolsas-financiamento.module';
import { IngressoComponent } from './ingresso/ingresso.component';
import { SobreComponent } from './sobre/sobre.component';
import { EgressosComponent } from './egressos/egressos.component';
import { CorpoDirigenteComponent } from './corpo-dirigente/corpo-dirigente.component';
import { GrupoCeumaComponent } from './grupo-ceuma/grupo-ceuma.component';
import { CorpoDirigenteService } from './corpo-dirigente/shared/corpo-dirigente.service';
import { CpaComponent } from './cpa/cpa.component';
import { PoliticasComponent } from './politicas/politicas.component';
import { EadComponent } from './ead/ead.component';
import { PerguntasFrequentesComponent } from './perguntas-frequentes/perguntas-frequentes.component';
import { PoliticasDePropiedadeIntelectual } from './politicas-de-propiedade-intelectual/politicas-de-propiedade-intelectual.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UniversidadeRouter,
    BolsasFinanciamentoModule,
    NoticiasModule,
  ],
  declarations: [
    UniversidadeComponent,
    IngressoComponent,
    SobreComponent,
    EgressosComponent,
    CorpoDirigenteComponent,
    GrupoCeumaComponent,
    CpaComponent,
    EadComponent,
    PoliticasComponent,
    NucleoComponent,
    NucleoDetalhesComponent,
    PerguntasFrequentesComponent,
    PoliticasDePropiedadeIntelectual,
  ],
  providers: [
    CorpoDirigenteService,
    NucleoService
  ],
})
export class UniversidadeModule { }
